import React from "react";
import {
  DecorativeIcon,
  DecorativeIconColor,
  DecorativeIconSize
} from "../../../Shared/Assets/DecorativeIcon/React";

interface ProvetFormHeaderProps {
  /** Optional title to display in the header */
  title?: string;
  /** Optional preamble text to display below the title */
  preamble?: string;
}

/**
 * Header component for the Provet booking form.
 *
 * Displays an optional title with a calendar icon.
 * Simple presentational component with no business logic.
 *
 * @param title - Optional title text to display. If not provided, header is not rendered.
 * @param preamble - Optional preamble text to display below the title.
 *
 * @example
 * ```tsx
 * <ProvetFormHeader title="Book an Appointment" />
 * ```
 */
export const ProvetFormHeader = ({ preamble, title }: ProvetFormHeaderProps) => {
  if (!title) {
    return null;
  }

  return (
    <header className="flex items-center gap-xs pb-lg font-guardian text-dark-blue">
      <DecorativeIcon
        color={DecorativeIconColor.LightBlue}
        sizeLg={DecorativeIconSize.Sm}
        symbol="calendar"
      />

      <div className="flex flex-col">
        <h1 className="text-h3 font-t-semi-bold">{title}</h1>

        {preamble && (
          <p className="text-t-xs font-t sm:text-t-sm lg:text-t-md">{preamble}</p>
        )}
      </div>
    </header>
  );
};

export default ProvetFormHeader;
